import React from "react";
import FlavorItem from "./FlavorItem";
import { useMediaQuery, useTheme } from "@mui/material";
import { lemonadesProductId, sortFrozenRecords, topFrozenRecords } from "./FlavorsList";

const FlavorCategoryItems = ({
  categoryIndex,
  category,
  tCount,
  scategory,
  scategoryIndex,
  storeOptionsArray,
  storeOptions,
  handleAllSellerCheck,
  handleSellerCheck,
  catering = false
}) => {
  const theme = useTheme();
  const disableSticky = useMediaQuery(theme.breakpoints.down('md'));

  const isFrozenLemonade = category?.intProductTypeID === lemonadesProductId;

  return (
    <div className="rounded-md bg-white" key={category?.intProductTypeID?.toString()}>
      <div className="card-header-border bg-white sticky top-[229px]" style={disableSticky ? { position: 'initial', top: 'unset' } : {}}>
        <div className={`grid divide-x-0 text-card-header`} style={{ gridTemplateColumns: `${catering ? 4 : 1}fr 1.5fr` }}>
          <div
            sx={{ width: 8 - `${tCount}` }}
            className="pl-2 text-card-header"
          >
            <h6 className="text-card-header my-5 ">
              [{scategory.start} - {scategory.end}]
            </h6>
          </div>
          <div sx={{ width: `${tCount}` }}>
            <div
              className={`grid divide-x my-5  text-center options-card-header `}
              style={{
                gridTemplateColumns: `repeat(${
                  storeOptionsArray?.length + (catering ? 0 : 1)
                },1fr)`,
              }}
            >
              {!catering && <div>
                <label title="All">All</label>
              </div>}
              {storeOptions.web && (
                <div>
                  <label title="www.ritasice.com">Web</label>
                </div>
              )}
              {storeOptions.dmb && (
                <div>
                  <label title="Digital Menu Boards">DMB</label>
                </div>
              )}
              {storeOptions.dt && (
                <div>
                  <label title="Drive Thru">DT</label>
                </div>
              )}
              {storeOptions.oo && (
                <div>
                  <label title="Online Ordering">OO</label>
                </div>
              )}
              {storeOptions.ct && (
                <div>
                  <label title="Catering">CT</label>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flow-root">
        <ul
          key={category?.intProductTypeID?.toString()}
          className="divide-gray-200 dark:divide-gray-700"
        >
          {(isFrozenLemonade ? sortFrozenRecords(scategory?.list) : scategory?.list).map((flv) => {
            let allValue = true;
            storeOptionsArray.forEach((i) => {
              if (!flv[i?.name]) {
                allValue = false;
              }
            });
            return (
              <FlavorItem
                catering={catering}
                categoryIndex={categoryIndex}
                category={category}
                scategory={scategory}
                flv={flv}
                scategoryIndex={scategoryIndex}
                storeOptionsArray={storeOptionsArray}
                storeOptions={storeOptions}
                handleAllSellerCheck={handleAllSellerCheck}
                handleSellerCheck={handleSellerCheck}
                allValue={allValue}
                tCount={tCount}
                topFrozenRecords={topFrozenRecords}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default FlavorCategoryItems;
